import React, { useEffect, useState } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { MdLocationOn, MdAccessTime, MdOutlineStar } from 'react-icons/md';
import { getEventTicketUrl } from '../WidgetConfig';

const HeaderSection = ({ restaurant }) => {
  const theme = useTheme();
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const photos = restaurant?.Photos || [];
  const coverImage = photos?.[activeImageIndex]?.Link || restaurant?.Logo;
  const events = restaurant?.Events || [];

  useEffect(() => {
    if (photos.length <= 1) return undefined;

    const interval = setInterval(() => {
      setActiveImageIndex((prevIndex) => (prevIndex + 1) % photos.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [photos.length]);

  useEffect(() => {
    setActiveImageIndex(0);
  }, [restaurant?.RestaurantId]);

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: '18px',
        overflow: 'hidden',
        boxShadow:
          theme.palette.mode === 'dark'
            ? 'none'
            : '0 18px 45px rgba(16, 24, 40, 0.04)',
      }}
    >
      <Box
        sx={{
          height: { xs: 300, md: 430 },
          position: 'relative',
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          overflow: 'hidden',
        }}
      >
        {photos.length > 0 ? (
          photos.map((photo, index) => (
            <Box
              key={photo?.Link || index}
              sx={{
                position: 'absolute',
                inset: 0,
                background: `linear-gradient(180deg, rgba(0,0,0,0.03) 0%, rgba(0,0,0,0.72) 100%), url('${photo?.Link}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                opacity: activeImageIndex === index ? 1 : 0,
                transition: 'opacity 700ms ease',
              }}
            />
          ))
        ) : (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: `linear-gradient(180deg, rgba(0,0,0,0.03) 0%, rgba(0,0,0,0.72) 100%), url('${coverImage}')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        )}
        {/* <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            alignSelf: 'flex-start',
            bgcolor: 'rgba(255,255,255,0.9)',
            borderRadius: '999px',
            px: 1.2,
            py: 0.5,
            fontSize: '11px',
            fontWeight: 700,
          }}
        >
      
          {restaurant?.RestaurantName}
        </Box> */}
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          {/* <Typography
            sx={{
              color: '#fff',
              fontWeight: 800,
              fontSize: '18px',
              lineHeight: 1.1,
            }}
          >
            {restaurant?.RestaurantName}
          </Typography> */}
          {/* <Typography sx={{ color: '#f5f5f5', fontSize: '12px', mt: 0.5 }}>
            Experience fine dining at our main dining room
          </Typography> */}
        </Box>
        {photos.length > 1 && (
          <Box
            sx={{
              position: 'absolute',
              right: 18,
              bottom: 22,
              zIndex: 2,
              display: 'flex',
              gap: 0.7,
              alignItems: 'center',
            }}
          >
            {photos.map((photo, index) => (
              <Box
                key={photo?.Link || index}
                onClick={() => setActiveImageIndex(index)}
                sx={{
                  width: activeImageIndex === index ? 22 : 7,
                  height: 7,
                  borderRadius: '999px',
                  bgcolor:
                    activeImageIndex === index
                      ? 'primary.main'
                      : 'rgba(255,255,255,0.55)',
                  cursor: 'pointer',
                  transition: 'all 200ms ease',
                }}
              />
            ))}
          </Box>
        )}
      </Box>

      <Box sx={{ p: 2.5 }}>
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: '18px',
            textTransform: 'uppercase',
            lineHeight: 1.1,
            color: 'text.primary',
          }}
        >
          {restaurant?.RestaurantName || '--'}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 1 }}>
          <MdOutlineStar style={{ color: '#f59e0b' }} />
          <Typography sx={{ fontSize: '12px', fontWeight: 700 }}>
            {restaurant?.ReviewDetails?.Rating || '4.8'}
          </Typography>
          <Typography sx={{ color: 'text.secondary', fontSize: '12px' }}>
            ({restaurant?.ReviewDetails?.TotalReview || '24'} reviews)
          </Typography>
        </Box>
        <Box sx={{ mt: 2, display: 'grid', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MdLocationOn style={{ color: '#9ca3af', flexShrink: 0 }} />
            <Typography sx={{ color: 'text.secondary', fontSize: '12px' }}>
              {restaurant?.LGA || restaurant?.State || restaurant?.Address}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MdAccessTime style={{ color: '#9ca3af', flexShrink: 0 }} />
            <Typography sx={{ color: 'text.secondary', fontSize: '12px' }}>
              Opens from {restaurant?.OpenFrom || '--'}
            </Typography>
          </Box>
        </Box>

        {events.length > 0 && (
          <Box sx={{ mt: 3, display: { md: 'block', xs: 'none' } }}>
            <Typography sx={{ fontWeight: 800, fontSize: '15px' }}>
              Special Events
            </Typography>
            <Typography
              sx={{ color: 'text.secondary', fontSize: '12px', mt: 1 }}
            >
              Join one of our exclusive dining experiences
            </Typography>
            {events.map((event, index) => {
              const eventTicketUrl = getEventTicketUrl(event);

              const eventKey =
                event?.Id ||
                event?.EventId ||
                event?.id ||
                event?.EventName ||
                index;

              return (
                <Box
                  key={eventKey}
                  sx={{
                    mt: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: '14px',
                    p: 1.2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                  }}
                >
                  <Box
                    sx={{
                      width: 72,
                      height: 72,
                      borderRadius: '12px',
                      background: `url('${event?.EventImage || coverImage}')`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      flexShrink: 0,
                    }}
                  />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: '13px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {event?.EventName || event?.name}
                    </Typography>
                    <Typography
                      sx={{
                        color: 'text.secondary',
                        fontSize: '11px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {event?.Description || 'Experience something special'}
                    </Typography>
                    <a
                      href={eventTicketUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Box
                        sx={{
                          mt: 1,
                          display: 'inline-flex',
                          bgcolor: 'primary.main',
                          color: 'primary.contrastText',
                          borderRadius: '8px',
                          px: 1.5,
                          py: 0.7,
                          fontWeight: 800,
                          fontSize: '11px',
                          textDecoration: 'none',
                          cursor: eventTicketUrl ? 'pointer' : 'default',
                          opacity: eventTicketUrl ? 1 : 0.6,
                          transition: 'opacity 150ms ease',
                          '&:hover': eventTicketUrl
                            ? { opacity: 0.9 }
                            : undefined,
                        }}
                      >
                        Book Now
                      </Box>
                    </a>
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default HeaderSection;
